<script>
  'use strict'

  import { _tilesCollections, _tilesCollectionFileName, _selectedTileIdx } from "../store/store";
  import TileImport from "./TileImport.svelte";
  import BtnUpdateTile from './BtnUpdateTile.svelte';

  let collectionSize = 0;

  // -------------------------------------------------
  _tilesCollections.subscribe(data => {
    collectionSize = data.length;
  });

  // -------------------------------------------------
  function deleteTile(idx) {
    // -- Delete in collection image
    let collectionIdx = [...$_tilesCollections];
    collectionIdx.splice(idx, 1);
    _tilesCollections.set(collectionIdx);
    // -- Delete in collection filename
    let collectionName = [...$_tilesCollectionFileName];
    collectionName.splice(idx, 1);
    _tilesCollectionFileName.set(collectionName); 
  }

  function setSelectedTile(idx) {
    _selectedTileIdx.set(idx);
  }
</script>


<div class="info-top">
  nbTiles: { collectionSize }
  <TileImport></TileImport>
</div>
<div class="tile-grid-collection">
  {#each $_tilesCollections as tile, idx}
  <div class="tile-card" class:tile-selected="{idx == $_selectedTileIdx}">
    <div class="tile-card-img">
      <img
        src="{ tile }"
        alt="tile"
        on:click="{() => setSelectedTile(idx)}"
      >
    </div>
    <button title="Delete tile" on:click="{() => deleteTile(idx)}">❌</button>
    <BtnUpdateTile idxToUpdate={idx}></BtnUpdateTile>
  </div>
  {/each}
</div>


<style>
  button {
    padding: 3px;
    min-width: auto;
  }

  img {
    width: 100%;
    aspect-ratio: 1/1;
    border: 1px solid var(--font-color);
    box-sizing: border-box;
  }

  .info-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .tile-grid-collection {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 12px;
    overflow: auto;
    max-height: 60vh;
    padding: 24px 0;
    border-top: 1px solid var(--hightlight-color);
    border-bottom: 1px solid var(--hightlight-color);

  }

  .tile-card {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    padding: 6px;
    background: var(--grid-color);
  }

  .tile-card-img {
    grid-column: 1/-1;
  }

  .tile-card-img:hover {
    cursor: pointer;
  }

  .tile-selected {
    background: var(--hightlight-color);
  }
</style>